import { Fragment } from 'react'
import classNames from 'classnames'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'

import { renderCell } from './AttachTasksModalTableRow.utils.js'

import * as styles from './AttachTasksModalTableRow.module.css'

function AttachTasksModalTableRow({
  Actions = TableRowActions,
  actionsColumnWidth,
  columns,
  disabled,
  emptyColumnSize,
  isSelected,
  item,
  readonly,
  onClick,
  ...restProps
}) {
  const { id } = item

  const { handleMouseEnter, handleMouseLeave, handleSelect } =
    useTableRowActions({ ...restProps, item, onClick })

  function handleClick() {
    onClick?.(id)
  }

  const rowClass = useTableRowModClassName({
    className: classNames(styles.AttachTasksModalTableRow, {
      [styles.readonly]: readonly || disabled,
    }),
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <div
      {...qaProps}
      className={rowClass}
      key={id}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          checked={isSelected}
          disabled={!isSelected && disabled}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            item,
            name: column.name,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default AttachTasksModalTableRow
